/* Kunstpflanzenmarkt: Warenkorb.
 *
 * Stepper und Entfernen schreiben über die Cart-API und laden die Seite
 * neu. Die komplette Versandrechnung (Paket, Spedition, Schwelle,
 * höhere Klasse gewinnt) liegt in sections/kpm-main-cart.liquid.
 * Sie hier ein zweites Mal in JS nachzubauen wäre genau der Weg, auf dem
 * Anzeige und Checkout auseinanderlaufen.
 */

(function () {
  'use strict';

  function change(key, quantity) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden');
      window.location.reload();
    });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-kpm-remove]');
    if (remove) {
      event.preventDefault();
      change(remove.dataset.kpmRemove, 0);
      return;
    }

    var step = event.target.closest('[data-kpm-qty]');
    if (!step) return;

    event.preventDefault();
    var input = document.querySelector('input[data-key="' + step.dataset.key + '"]');
    if (!input) return;

    var current = parseInt(input.value, 10) || 0;
    var next = step.dataset.kpmQty === 'up' ? current + 1 : current - 1;
    if (next < 0) next = 0;

    // Menge 0 entfernt die Position, so steht es im Handoff.
    change(step.dataset.key, next);
  });
})();
